import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const getSchema = () => {
  const { t } = useTranslation();

  return yup.object().shape({
    name: yup.string().required(t("validation.required")),
    positions: yup
      .array()
      .required(t("validation.required"))
      .min(1, t("validation.required")),
  });
};
